import React from "react";

import Table from "../../../common/Table";

import lbl from "../../../../data/Labels.json";

const RevenuesCard = ({ data }) => {
  const _data = {
    data: data?.revenues || [],
    summary: data?.revenuesSummary || [],
  };

  const columns = [
    { path: "id", label: "شماره" },

    {
      path: "name",
      label: "حوزه های درآمد",
    },
    {
      path: "payable",
      label: "قابل دریافت",
    },
    {
      path: "paid",
      label: "دریافت شده",
    },
    {
      path: "balance",
      label: "باقی مانده",
    },
  ];

  return (
    <div className="finance-wrapper-box">
      <h5 className="title">{lbl.Revenues}</h5>
      <div className="table">
        <Table data={_data} columns={columns} />
      </div>
    </div>
  );
};

export default RevenuesCard;
